import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { ItemStates } from '@site-mate/dashpivot-shared-library';

import { UserService } from 'app/user/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule],
  selector: 'cc-lists-grid-empty-state',
  templateUrl: './lists-grid-empty-state.component.html',
  styleUrls: ['./lists-grid-empty-state.component.scss'],
})
export class ListsGridEmptyStateComponent implements OnInit {
  isArchivedView = false;
  canAddList$: Observable<boolean>;

  constructor(private route: ActivatedRoute, private userService: UserService) {}

  ngOnInit() {
    const { data, params } = this.route.snapshot;

    this.isArchivedView = data.state === ItemStates.Archived;
    this.canAddList$ = params.projectId
      ? this.userService.isProjectControllerOrAbove$()
      : this.userService.isCompanyControllerOrAbove$();
  }
}
